export var transformName = function transformName(analysisName) {
  return analysisName.split('_').join(' ');
};